var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c("div", { staticClass: "grid-container fluid" }, [
      _vm.informationFirst
        ? _c(
            "div",
            {
              staticClass: "grid-x grid-margin-x",
              attrs: { "data-test": "information-first" },
            },
            [
              _c("div", {
                staticClass: "cell",
                domProps: { innerHTML: _vm._s(_vm.informationFirst) },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid-margin-x boss-bgcolor-white-gray padding-top-1" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("section", { staticClass: "cell" }, [
            _vm.isSelectionConfirmation
              ? _c(
                  "div",
                  {
                    staticClass: "pega-notice-label pega-input",
                    attrs: { "data-test": "selection-confirmation" },
                    on: {
                      click: function ($event) {
                        return _vm.onClick(
                          "phases_and_statuses",
                          _vm.goSettingsSelection
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          （ご利用の前に）御社の[選考フェーズ・選考ステータス]をご確認ください。\n        "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isBeforePublishedConfirmation
              ? _c(
                  "div",
                  {
                    staticClass: "pega-notice-label pega-input",
                    attrs: { "data-test": "before-published-confirmation" },
                    on: {
                      click: function ($event) {
                        return _vm.onClick(
                          "before_publishing_checklist",
                          _vm.goCheckList
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          （ご利用の前に）掲載前チェックリストをご確認ください\n        "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.newEntryCount
              ? _c(
                  "div",
                  {
                    staticClass: "pega-notice-label pega-input",
                    attrs: { "data-test": "new-entry-count" },
                    on: {
                      click: function ($event) {
                        return _vm.onClick("", _vm.goEntryTop)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          新しい応募が" +
                        _vm._s(_vm.newEntryCount) +
                        "件あります。\n        "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showNewMessageCount
              ? _c(
                  "div",
                  {
                    staticClass: "pega-notice-label pega-input",
                    attrs: { "data-test": "new-message-count" },
                    on: {
                      click: function ($event) {
                        return _vm.onClick("", _vm.goEntryTop)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          新しいメッセージが届きました。" +
                        _vm._s(_vm.newMessageCountText) +
                        "\n        "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isSearchNewUsers
              ? _c(
                  "div",
                  {
                    staticClass: "pega-notice-label pega-input",
                    attrs: { "data-test": "search-new-users" },
                    on: {
                      click: function ($event) {
                        return _vm.onClick(
                          "updated_user_resume",
                          _vm.goScoutTop
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          保存した検索条件に、新しい会員がヒットしました。スカウトを送ってみませんか\n        "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isRecommendedNewUsers
              ? _c(
                  "div",
                  {
                    staticClass: "pega-notice-label pega-input hover",
                    attrs: { "data-test": "recommended-new-users" },
                    on: {
                      click: function ($event) {
                        return _vm.onClick(
                          "new_recommended_users",
                          _vm.goScoutTop
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          おすすめ会員が更新されました。スカウトを送ってみませんか\n        "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isInterviewCandidateDateConfirmation
              ? _c(
                  "div",
                  {
                    staticClass: "pega-notice-label pega-input",
                    attrs: {
                      "data-test": "interview-candidate-date-confirmation",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onClick(
                          "new_publishing_interview_candidate_date",
                          _vm.goInterviewCandidateDateTop
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          一次面接候補日の設定が必要な方は、ご確認ください。\n        "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          !!_vm.informations.length
            ? _c("informations", { attrs: { informations: _vm.informations } })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showScout
        ? _c("div", { staticClass: "grid-x grid-margin-x" }, [
            _c("div", { staticClass: "width-100" }, [
              _c(
                "section",
                { staticClass: "boss-pickup-container" },
                [_c("scout-recommended-members")],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.informationThird
        ? _c(
            "div",
            {
              staticClass: "grid-x grid-margin-x margin-top-1",
              attrs: { "data-test": "information-third" },
            },
            [
              _c("div", {
                staticClass: "cell",
                domProps: { innerHTML: _vm._s(_vm.informationThird) },
              }),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell pega-notice-header" }, [
      _c("img", {
        staticClass: "pega-icon-bell",
        attrs: { src: require("@/assets/images/bell.png") },
      }),
      _vm._v(" "),
      _c("span", [_vm._v("お知らせ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }